// routes/_main/orders/index.tsx
import { OrdersStream } from "@/components/tables/orders-stream"; // NEW
import { Button } from "@/components/ui/button";
import { buildMetadata } from "@/lib/metadata";
import { OrderService } from "@/services/order-services";
import { Link, createFileRoute } from "@tanstack/react-router";
import { UploadCloud } from "lucide-react";

export const Route = createFileRoute("/_main/orders/")({
  component: RouteComponent,
  loader: async () => {
    // ✅ Only fetch the FIRST page so we can render immediately
    const firstPage = await OrderService.getOrdersPage({
      page: 1,
      pageSize: 10,
    });
    return { firstPage };
  },
  head: () => ({
    meta: buildMetadata({
      title: "Channel Genie",
      description: "View all orders",
      keywords: ["orders", "order", "view"],
    }),
  }),
});

function RouteComponent() {
  const { firstPage } = Route.useLoaderData() as {
    firstPage: Awaited<ReturnType<typeof OrderService.getOrdersPage>>;
  };

  return (
    <div className="space-y-8 p-4 md:p-8">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="space-y-1" />
        <Button
          asChild
          size="lg"
          className="self-start rounded-xl bg-foreground text-background hover:bg-foreground/90"
        >
          <Link to="/orders/upload">
            <UploadCloud className="size-4" />
            Upload Orders
          </Link>
        </Button>
      </div>

      {/* ✅ This component renders page 1 immediately and streams the rest */}
      <OrdersStream firstPage={firstPage} pageSize={50} />
    </div>
  );
}
